import React, { Component } from 'react';

import { Parallax } from 'react-parallax';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';

class OnePicture extends Component {
    state = {
        heightImg: null,
    };

    imgContainer = React.createRef();

    componentDidMount() {
        this.setState({
            heightImg: this.imgContainer.current.clientWidth * 5,
        });
    }

    getPicture = () => {
        if (typeof window === 'undefined') {
            return '/images/pic/tech-leaders/tech-leaders-one-picture__img.png';
        }

        if (window.matchMedia('(max-width: 575px)').matches) {
            return '/images/pic/tech-leaders/tech-leaders-one-picture__img.jpg';
        } else {
            return '/images/pic/tech-leaders/tech-leaders-one-picture__img.png';
        }
    };

    render() {
        return (
            <ScrollAnimation animateIn="fadeIn" offset={50} animateOnce={true} duration={1}>
                <FullWrapper className="tech-leaders-one-picture">
                    <div
                        id="tech-leaders-one-picture-parallax"
                        ref={this.imgContainer}
                        className="tech-leaders-one-picture__wrapper"
                    >
                        <Parallax
                            blur={0}
                            bgImage={this.getPicture()}
                            strength={this.state.heightImg}
                        >
                            <div style={{ height: '70vh' }} />
                        </Parallax>
                    </div>
                </FullWrapper>
            </ScrollAnimation>
        );
    }
}

export default OnePicture;
